import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

const UrlListarEvaluaciones = ApiUrl + "evaluaciones-docentes?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";  // Ruta para listar evaluaciones
const urlInsertarEvaluacion = ApiUrl + "evaluaciones-docentes?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";  // Ruta para insertar evaluación
const urlActualizarEvaluacion = ApiUrl + "evaluaciones-docentes";  // Ruta para insertar evaluación
const api_key = "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71"

let listaauxiliar = [];
const itemsPerPage = 4;

const estados = ["Activo", "Inactivo"];

export default class GestionEvaluaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagina: 0,
            evaluaciones: [],
            modalReportIngresarEvaluacion: false,
            listaEvaluaciones: [],
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            id: 0,
            titulo: "",
            descripcion: "",
            estado: "Activo" // Estado por defecto
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeListarEvaluaciones = async () => {
        axios.get(UrlListarEvaluaciones).then(respuesta => {
            const evaluaciones = respuesta.data;
            this.setState({ evaluaciones, listaEvaluaciones: evaluaciones });
            listaauxiliar = evaluaciones;
            const endOffset = this.state.itemOffset + itemsPerPage;
            this.setState({
                currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset),
                pageCount: Math.ceil(listaauxiliar.length / itemsPerPage)
            });
        });
    }

    componentDidMount() {
        this.handleChangeListarEvaluaciones();
    }

    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        const endOffset = newOffset + itemsPerPage;
        this.setState({
            itemOffset: newOffset,
            currentItems: listaauxiliar.slice(newOffset, endOffset)
        });
    }

    mostrarModalIngresar = () => {
        this.setState({ id: 0, titulo: "", descripcion: "", estado: "Activo", modalReportIngresarEvaluacion: true });
    }

    mostrarModalModificar = (registro) => {

        $(function () {
            $("#id").val(registro.id);
            $("#titulo").val(registro.titulo);
            $("#descripcion").val(registro.descripcion);
            $("#estado").val(registro.estado);
        });

        this.setState({
            id: registro.id,
            titulo: registro.titulo,
            descripcion: registro.descripcion,
            estado: registro.estado,
            modalReportIngresarEvaluacion: true
        });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarEvaluacion: false });
    }

    registrarEvaluacion = () => {
        const { id, titulo, descripcion, estado } = this.state;
        const datos = { id, titulo, descripcion, estado };
        const url = id === 0 ? urlInsertarEvaluacion : `${urlActualizarEvaluacion}/${id}${api_key}`;
        const metodo = id === 0 ? "post" : "put";

        axios[metodo](url, datos).then(response => {
            if (response.data.success) {
                swal("Operación Exitosa!", { icon: "success" });
                this.handleChangeListarEvaluaciones();
                this.ocultarModalIngresar();
            }
        }).catch(() => {
            swal("Error en la operación", { icon: "error" });
        });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active"></li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="card-header back-istmas">
                        <i className="far fa-sticky-note"></i>
                        <b> Gestión de Evaluaciones Docentes</b>
                    </div>
                    <div className="card-body">
                        <div className="card border-dark text-center ">
                            <div className="card-header ">
                                <b>REPORTE DE EVALUACIONES</b>
                            </div>
                            <div class="table-responsive">
                                <table className="table table-bordered" id="tablaevaluaciones" name="tablaevaluaciones" width="100%" >
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Descripción</th>
                                            <th>Estado</th>
                                            <th>Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.currentItems && this.state.currentItems.map((evaluacion) => (
                                            <tr key={evaluacion.id}>
                                                <td>{evaluacion.id}</td>
                                                <td>{evaluacion.titulo}</td>
                                                <td>{evaluacion.descripcion}</td>
                                                {(() => {
                                                    if (evaluacion.estado == "Activo") {
                                                        return <td class="estado table-success">{evaluacion.estado}</td>
                                                    }
                                                    if (evaluacion.estado == "Inactivo") {
                                                        return <td class="estado table-danger">{evaluacion.estado}</td>
                                                    }
                                                })()}
                                                <td>
                                                    <button onClick={() => this.mostrarModalModificar(evaluacion)}>
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="table-responsive">
                                    <ReactPaginate
                                        nextLabel="siguiente >"
                                        onPageChange={this.handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={2}
                                        previousLabel="< anterior"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                </div>
                                <Modal isOpen={this.state.modalReportIngresarEvaluacion}>
                                    <ModalHeader>
                                        Registro de Evaluación
                                    </ModalHeader>
                                    <ModalBody>
                                        <FormGroup>
                                            <div className="mb-3 centrar">
                                                <input type="hidden" name="id" class="id" id="id" value="" />
                                                <label>Título:</label>
                                                <input type="text" id="titulo" name="titulo" onChange={this.handleChange} className="form-control" placeholder="Ingrese el título de la evaluación" autocomplete="off" required />
                                                <label>Descripción:</label>
                                                <textarea id="descripcion" name="descripcion" onChange={this.handleChange} className="form-control" placeholder="Ingrese la descripción de la evaluación" rows="3"  autocomplete="off" required></textarea>
                                                <label>Estado:</label>
                                                <select name="estado" value={this.state.estado} onChange={this.handleChange} className="form-control">
                                                    {estados.map(estado => <option key={estado} value={estado}>{estado}</option>)}
                                                </select>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button class="btn btn-success" onClick={() => this.registrarEvaluacion()}>Guardar</button>
                                        <button class="btn btn-danger" onClick={() => this.ocultarModalIngresar()}>Cancelar</button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                        </div>
                        <button className="btn btn-primary mt-3" onClick={() => this.mostrarModalIngresar()}>Agregar Evaluación</button>
                    </div>
                </div>
            </div>
        )
    }
}